export function followOutageMessage(warned: boolean): string {
  return warned
    ? "Hepha API still unavailable; retrying follow."
    : "Hepha API unavailable; retrying follow.";
}
